import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPermissions } from '@models/Configuration/IPermissions';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { AssetsPipe } from '@pipes/assets.pipe';
import { BusService } from '@services/bus.service';
import { ConfigService } from '@services/config.service';
import { EventsService } from '@services/events.service';
import { IdeaRequestService } from '@services/sessions/idea.request.service';

@Component({
  selector: 'app-idea-card-small',
  templateUrl: './idea-card-small.component.html',
  styleUrls: ['./idea-card-small.component.scss'],
})
export class SessionIdeaCardSmallComponent {
  @Input() session: Session;
  @Input() idea: Idea;
  @Output() ideaAction = new EventEmitter<Idea>();

  permissions: IPermissions;

  constructor(
    private appConfig: ConfigService,
    private bus: BusService,
    private events: EventsService,
    private ideaRequest: IdeaRequestService,
    private assetsPipe: AssetsPipe,
  ) {
    this.permissions = appConfig.permissions;
  }

  get thumbnailImage() {
    return this.assetsPipe.transform(
      this.idea.thumbnail_id || 'image/default_idea_thumbnail.png',
    );
  }

  publish() {
    this.bus.publish(
      this.events.requested.action.session.idea.publish,
      this.idea,
      this.session,
    );
  }

  unpublish() {
    this.bus.publish(
      this.events.requested.action.session.idea.unpublish,
      this.idea,
      this.session,
    );
  }

  openIdea() {
    if (this.ideaAction.observers.length) {
      this.ideaAction.emit(this.idea);
    }
  }
}
